import { EventHandler, SyntheticEvent, useCallback } from "react";
import { ActionCreator } from "redux";
import { useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";

import { skipTextBackward, skipTextForward } from "../../store/modules/audio/actions";
import { AudioSkipTextBackward, AudioSkipTextForward } from "../../store/modules/audio/actionTypes";
import { hasActiveRecord } from "../../store/modules/library/selectors";

type SkipActionCreator = ActionCreator<AudioSkipTextForward | AudioSkipTextBackward>;

const useSkip = (action: SkipActionCreator) => {
  const dispatch = useDispatch();
  const canSkip = useSelector(hasActiveRecord);

  return useCallback<EventHandler<SyntheticEvent>>((event) => {
    event.preventDefault();

    if (canSkip) {
      dispatch(action());
    } else {
      toastr.warning("Skip Record", "Active Record does not exist.");
    }
  }, [action, canSkip, dispatch]);
};

export const useSkipBackward = () => useSkip(skipTextBackward);
export const useSkipForward = () => useSkip(skipTextForward);
